import { User } from '../types';

const STORAGE_KEY = 'planningUser';

function removePersistedUser() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage may be unavailable due to browser policy or privacy settings.
  }
}

export function loadJoinMetadata(roomId: string): string | null {
  let raw: string | null;

  try {
    raw = localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }

  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    const nickname =
      typeof parsed?.nickname === 'string' ? parsed.nickname : 'unknown';

    if (parsed?.roomId === roomId) {
      return raw;
    }

    return JSON.stringify({
      nickname,
      roomId,
      mod: { enabled: false, showResults: false, allowVote: false },
    });
  } catch {
    removePersistedUser();
    return null;
  }
}

export function savePersistedUser(metadata: User['metadata']): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(metadata));
  } catch {
    // The room remains usable when persistence is unavailable or full.
  }
}
